import Component from '@glimmer/component'
import { service } from '@ember/service'
import { ButtonAppearance, appearanceToThemeClasses } from 'teacher-ui-client/components/ui-button/themes'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'

interface Signature {
  Element: HTMLButtonElement
  Args: {
    Named: {
      appearance?: ButtonAppearance
      disabled?: boolean
    }
  }
  Blocks: {
    default: []
  }
}

export class UiButton extends Component<Signature> {
  @service subscriptionType!: SubscriptionTypeService

  get themeClasses() {
    return appearanceToThemeClasses(this.args.appearance ?? ButtonAppearance.muted, this.subscriptionType.current).join(
      ' ',
    )
  }

  <template>
    <button
      class="rounded-md px-5 py-2 align-middle transition-all duration-200 select-none {{this.themeClasses}}"
      type="button"
      disabled={{@disabled}}
      ...attributes
    >
      {{yield}}
    </button>
  </template>
}

export default UiButton
